module.exports = __webpack_public_path__ + "static/media/we-logo.8d0c59ac.jpg";